// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3oiiY","Loader":"Loader_Loader__2vNEx","lds-spinner":"Loader_lds-spinner__2OAi4"};